import { Route } from 'react-router-dom';
import { AuthPage } from '../pages';

const AuthRoutes = () => {
  return (
    <>
      <Route path="/login" element={<AuthPage />} />
      <Route path="/device-registration-login" element={<AuthPage />} />
      <Route path="/forgot-password" element={<AuthPage />} />
      <Route path="/otp-verification" element={<AuthPage />} />
      <Route path="/complete-registration" element={<AuthPage />} />
    </>
  );
};

export default AuthRoutes;
